module.exports = __webpack_public_path__ + "img/groupBackgroundImg.28a5c51f.png";